import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import BidCommunicationCenterTable from './change-notification-table';
import { GET_BID_ELEMENTS_CHANGE_HISTORY } from '../bids.gql';

const BidCommunicationCenter = ({ bidId, solicitationId }) => {

    const [paginationState, setPaginationState] = useState({
      limit: 100,
      offset: 0,
      currentPage: 1,
    });

  const {
    data,
    error,
    loading: isDataLoading,
    refetch,
  } = useQuery(GET_BID_ELEMENTS_CHANGE_HISTORY, {
    fetchPolicy: 'network-only',
    variables: {
      bidId: parseInt(bidId, 10),
      solicitationId: parseInt(solicitationId, 10),
      limit: paginationState.limit,
      offset: paginationState.offset,
    },
    skip: !bidId,
  });

  const rawData = data?.getBidElementsChangeWithHistory;
  const uniqueRows = (rawData?.rows || []).filter(
    (item, index, self) =>
      index ===
      self.findIndex(
        (t) =>
          t.standardItem?.standardItemNumber ===
            item.standardItem?.standardItemNumber &&
          t.equipmentCode?.code === item.equipmentCode?.code &&
          t.changeType === item.changeType &&
          t.createdAt === item.createdAt,
      ),
  );
  const tableData = rawData
    ? { ...rawData, rows: uniqueRows, count: uniqueRows.length }
    : rawData;

  return (
    <BidCommunicationCenterTable
      tableData={tableData}
      error={error}
      isDataLoading={isDataLoading}
      paginationState={paginationState}
      setPaginationState={setPaginationState}
      refetch={refetch}
    />
  );
};

BidCommunicationCenter.propTypes = {
  bidId: PropTypes.number.isRequired,
  solicitationId: PropTypes.number.isRequired,
};

export default BidCommunicationCenter;
